import EmptyStatus from '../empty-status'
import { Flex } from '@chakra-ui/react'
import OrderCard from '../order-card'
import { ISingleOrder } from '@/_service/types/orders'
import { getBrandSlug } from '@/_lib/brand-href'
import { useRouter } from '@/i18n/navigation'

export default function OrderList({ isLoading, ordersData }: {
    isLoading: boolean, ordersData: {
        orders: ISingleOrder[];
        count: number | string;
    } | undefined
}) {
    const router = useRouter();

    const handleOrderClick = (order: ISingleOrder) => {
        const shipperSlug = getBrandSlug(order.shipper.id);
        router.push(`/orders/${order.id}?shipper_id=${shipperSlug}`);
    };


    if (!isLoading && ordersData?.count == 0) {
        return (
            <EmptyStatus />
        )
    } else return (
        <Flex direction='column' gap='2' w='full' px='4'>
            {ordersData?.orders?.map((order) => (
                <OrderCard key={order.id} order={order} onClick={handleOrderClick} />
            ))}
        </Flex>
    )
}
